import React, { useState, useEffect } from "react";
// material
import { Alert, AlertTitle, Button } from "@mui/material";
// components
import Loader from "src/components/loader/Loader";
import Page from "../components/Page";
import { useDispatch } from "react-redux";
import { get, post } from "src/services/content.service";
import saveAs from "file-saver";
import { fDateTime } from "../utils/formatTime";
import axios from "axios";
import { useTranslation } from "react-i18next";

// components

const LicenseGenerator = () => {
    const [license, setLicense] = useState(null);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        const fetchLicense = async () => {
            setLoading(true);
            try {
                const res = await get(dispatch, `/api/license/`);
                setLicense({
                    status: true,
                    ...res.data,
                });
            } catch (err) {
                setLicense({ status: false });
            } finally {
                setLoading(false);
            }
        };

        fetchLicense();
    }, []);

    const generate = async () => {
        setLoading(true);
        try {
            const res = await post(dispatch, `/api/license/`);
            setLicense({
                ...res.data,
                status: true,
            });
        } catch (err) {
            setLicense({ status: false });
        } finally {
            setLoading(false);
        }
    };

    const handleClick = () => {
        if (license?.status) {
            saveAs(`${axios.defaults.baseURL}${license.pdf}`, license.name);
        } else {
            generate();
        }
    };

    const renderAlert = () => {
        const valid = license?.status === true || false;
        const created =
            license && license.created ? fDateTime(license.created) : 0;

        return (
            <Alert
                severity={valid ? "success" : "warning"}
                action={
                    <Button color="inherit" size="small" onClick={handleClick}>
                        {valid ? t('buttonCommons.download') : t('buttonCommons.generate')}
                    </Button>
                }
            >
                <AlertTitle>{`${t("statusCommon.status")} ${
                    valid ? t("statusCommon.active") : t("statusCommon.inactive")
                }`}</AlertTitle>
                {valid
                    ? t("LicenseGenerator.licenseActiveSince", {createdAt: created})
                    : t("LicenseGenerator.licenseNotCreated")}
            </Alert>
        );
    };

    return (
        <Page title={t("SidebarConfig.sidebar.licenseGenerator.title")}>
            {loading ? <Loader /> : renderAlert()}
        </Page>
    );
};

export default LicenseGenerator;
